import axios from 'axios'

const API_URL = "https://arturospizza.com.au/pizza-backend/api";

const state = {
    category: [],
    defaultPizzaSizes: [
        { id: 1, name: 'SMALL - 9"', price: '14.90' },
        { id: 2, name: 'LARGE - 11"', price: '17.90' },
        { id: 3, name: 'FAMILY - 13"', price: '20.90' },
    ],
    settings: [],
    show_preloader: true,
    show_preloadermini: false,
    online_ordering_enabled: 1,
    online_ordering_disable_message: ""
};
const actions = {
    async getAllCategory({ commit }) {
        let url = API_URL + '/all-category';
        await axios.get(url).then(response => {
            let catData = response.data
            commit('updateCategoryList', catData);
            commit('updateShowPreloader', false);
        })
    },
    async getOnlineOrderingStatus({ commit }) {
        let url = API_URL + '/ordering-active';
        await axios.get(url).then(response => {
            let sData = response.data
            commit('updateOnlineOrderingStatus', sData);
        })
    },
    async getSettings({ commit }) {
        let url = API_URL + '/all-settings';
        await axios.get(url).then(response => {
            let settings = response.data
            commit('updateSettings', settings)
        })
    }
};
const mutations = {
    updateCategoryList(state, payload) {
        state.category = payload
    },
    updateSettings(state, payload) {
        state.settings = payload;
    },
    updateOnlineOrderingStatus(state, payload) {
        state.online_ordering_enabled = payload.enabled;
        state.online_ordering_disable_message = payload.message;
    },
    updateShowPreloader(state, payload) {
        state.show_preloader = payload;
    },
    updateShowPreloaderMini(state, payload) {
        state.show_preloadermini = payload;
    }
};
const getters = {
    getAllCategory: (state) => state.category,
    getDefaultPizzaSizes: (state) => state.defaultPizzaSizes,
    settings: (state) => state.settings,
    onlineOrderingEnabled: (state) => state.online_ordering_enabled,
    onlineOrderingDisableMessage: (state) => state.online_ordering_disable_message,
    showPreloader: (state) => state.show_preloader,
    showPreloaderMini: (state) => state.show_preloadermini
};
export default {
    state,
    actions,
    mutations,
    getters
};